export default "__VITE_ASSET__C4uN_oFl__ 1200w";